import React, { Component } from 'react'
import { css } from 'emotion'
import { promotions, foodGallery1, foodGallery2, bgwatermark } from 'images'
import { MEDIA_QUERY } from 'styles'

class Promotions extends Component {
  render() {
    return (
      <div className={styles.container}>
        <img
          src={foodGallery1}
          className={styles.foodGallery}
          alt="Food Gallery"
        />
        <div className={styles.sectionBG}>
          <img src={promotions} className={styles.section} alt="About" />
        </div>
        <img
          src={foodGallery2}
          className={styles.foodGallery}
          alt="Food Gallery"
        />
      </div>
    )
  }
}

const styles = {
  container: css({
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    maxWidth: '130rem',
    paddingTop: '2rem',
    paddingBottom: '1rem',
    [MEDIA_QUERY.MD]: {
      padding: '1rem 0 1rem 0',
    },
  }),
  foodGallery: css({
    objectFit: 'contain',
    width: '100%',
  }),
  section: css({
    objectFit: 'contain',
    width: '90%',
    paddingTop: '2rem',
    [MEDIA_QUERY.MD]: {
      padding: '1rem 0 .5rem 0',
    },
  }),
  sectionBG: css({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100vw',
    background: `url(${bgwatermark}) no-repeat`,
    backgroundSize: 'contain',
  }),
}

export default Promotions
